import React from 'react';
import { useFilterContext } from '../../context/aptmetrix/FilterContext';
import { useTooltip } from './useTooltip';
import { handleIntegerInput } from './inputHelpers';
import FilterButton from './FilterButton';
import TooltipShell, { FilterActions } from './TooltipShell';

const HouseholdFilter = ({ isOpen, onToggle, onClose, selectedRegion, data, onFilterChange }) => {
    const {
        filterUIState,
        setFilterUIState,
        setHouseholdFilter,
    } = useFilterContext();

    const { minHousehold, maxHousehold, isHouseholdFilterActive } = filterUIState;

    const { tooltipRef, buttonRef } = useTooltip(isOpen, onClose);

    const updateUI = (updates) => setFilterUIState(prev => ({ ...prev, ...updates }));
    const setMinHousehold = (v) => updateUI({ minHousehold: v });
    const setMaxHousehold = (v) => updateUI({ maxHousehold: v });

    const handleToggle = () => {
        if (!selectedRegion) {
            alert('지역을 먼저 선택하세요');
            return;
        }
        onToggle();
    };

    const apply = () => {
        const minVal = minHousehold ? parseInt(minHousehold, 10) : null;
        const maxVal = maxHousehold ? parseInt(maxHousehold, 10) : null;
        updateUI({ isHouseholdFilterActive: minVal !== null || maxVal !== null });
        setHouseholdFilter({ minHousehold: minVal, maxHousehold: maxVal });
        onFilterChange({ minHousehold: minVal, maxHousehold: maxVal });
        onClose();
    };

    const reset = () => {
        updateUI({ minHousehold: '', maxHousehold: '', isHouseholdFilterActive: false });
        setHouseholdFilter({ minHousehold: null, maxHousehold: null });
        onFilterChange({ minHousehold: null, maxHousehold: null });
        onClose();
    };

    const isDisabled = !data || data.length === 0;

    return (
        <div className="relative">
            <FilterButton
                ref={buttonRef}
                label="세대수"
                activeLabel="세대수적용"
                isActive={isHouseholdFilterActive}
                isDisabled={isDisabled}
                onClick={handleToggle}
            />
            {isOpen && (
                <TooltipShell ref={tooltipRef} title="총세대수 설정" onClose={onClose}>
                    <div className="flex items-center justify-between mb-3">
                        <input
                            type="text"
                            value={minHousehold}
                            onChange={(e) => handleIntegerInput(e, setMinHousehold)}
                            placeholder="최소 세대수"
                            className="w-24 p-1 border border-gray-300 rounded-lg text-center text-sm"
                        />
                        <span className="mx-1">~</span>
                        <input
                            type="text"
                            value={maxHousehold}
                            onChange={(e) => handleIntegerInput(e, setMaxHousehold)}
                            placeholder="최대 세대수"
                            className="w-24 p-1 border border-gray-300 rounded-lg text-center text-sm"
                        />
                    </div>
                    <div className="text-xs text-gray-500 mb-2 text-right">(단위: 세대)</div>
                    <FilterActions onReset={reset} onApply={apply} />
                </TooltipShell>
            )}
        </div>
    );
};

export default HouseholdFilter;
